import React, { useState } from 'react';
import MainCalculatorsList from '../MainCalculators';
import RelatedLinks from '../RelatedLinks';
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
import { SERVER_URL } from '../ConstantsEN';
import { Ovulation_EndPoint } from '../ConstantsEN';
import { CalculatorsType } from '../ConstantsEN';
import { OvulationTableFull } from './Tables';
import { CycleLengthComponent } from './Component';
import SharedHelmet from "../Helmet";
const TITLE = 'Ovulation Calculator - Calculate Ovulation Days and Intercourse Timing';
const DESCRIPTION = 'Calculate suitable ovulation days for women in Gregorian or Hijri date and know the best time for intercourse to achieve pregnancy using the ovulation calculator.';
const KEYWORDS = 'ovulation calculator, ovulation timing';
const OG_URL = 'https://do-calculate.com/calculator/en/ovulation/';
const apiEndpoint = `${SERVER_URL}/${Ovulation_EndPoint}`;
function OvulationCalculator() {
    const [firstDayOfLastPeriod, setFirstDate] = useState();
    const [cycleLength, setCyrcleLength] = useState(28);
    const [result, setRestul] = useState(null);
    const [statusCode, setStatusCode] = useState(null);
    const handleDateChange = (event) => {
        setFirstDate(event.target.value)
    };
    const calculateOvulation = async () => {
        try {
            const response = await fetch(apiEndpoint, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ firstDayOfLastPeriod, cycleLength }),
            });
            const data = await response.json();
            setStatusCode(response.status);
            if (response.ok) {
                setRestul(data.result);
            } else {
                setRestul(null);
            }
        } catch (error) {
            console.error(error);
        }
    };
    return (
        <div>
            <SharedHelmet
                TITLE={TITLE}
                DESCRIPTION={DESCRIPTION}
                KEYWORDS={KEYWORDS}
                OG_URL={OG_URL}
            />
            <div className="row">
                <div className="col-12 col-md-8">
                    <FirstAds />
                </div>
            </div>
            <div className="row">
                <div className="col-12 col-md-8">
                    <div className="bg-success text-white text-center" style={{ height: '40px', }}><b>
                        <h1 style={{ fontSize: '15px' }}> Ovulation Calculator - Calculate Ovulation Days and Intercourse Timing </h1>
                    </b></div>
                    <div className="border border-light">
                        <div className="row">
                            <div>
                                The Ovulation Calculator estimates the most probable ovulation and fertility window, along with related dates. The estimation is based on a woman's last menstrual cycle date. This calculator should not be used as a method of contraception.
                                <br />
                                <hr />
                            </div>
                            <br />
                        </div>
                        <MobileUnderCalAds />
                        <div className="row">
                            <div className='col-12 col-md-5 calculatorStyle'>
                                <div className='p-3 mb-2 bg-success text-white'>
                                    <h2 style={{ fontSize: '15px' }}> Ovulation Days Calculator </h2>
                                </div>
                                <hr />
                                <br />
                                <div className=" form-group d-flex align-items-center">
                                    <b>  <label className="form-label ms-2" >
                                        <strong>Your first day</strong> of your last menstrual cycle:
                                    </label>
                                    </b>
                                    <br />
                                    <input
                                        type="date"
                                        id="weightNumber"
                                        value={firstDayOfLastPeriod}
                                        onChange={handleDateChange}
                                        className="form-control ml-2"
                                        style={{ width: '145px' }}
                                        placeholder="175"
                                    />
                                </div>
                                <br />
                                <div className="form-group d-flex align-items-center">
                                    <b>  <label htmlFor="CycleLength" className="form-label ms-2">
                                        Average time between cycles
                                    </label>
                                    </b>
                                    <CycleLengthComponent handleDateChange={setCyrcleLength} />
                                    <div className="input-group-append">
                                        <span className="input-group-text ">days</span>
                                    </div>
                                </div>
                                <br />
                                <hr />
                                <div>
                                    <button className="btn btn-success" style={{ fontSize: '20px' }} onClick={
                                        calculateOvulation}>Calculate </button>
                                </div>
                            </div>
                            <div className="col-sm-12 col-md-7">
                                <br />
                                {statusCode === 400 && <div className="alert alert-warning"><b><u> Error:</u></b> Please enter all fields correctly. </div>}
                                {result &&
                                    (
                                        <div>
                                            <h4><div className="p-3 mb-2 bg-success text-white">Results: </div></h4>
                                            <hr />
                                            <OvulationTableFull result={result}></OvulationTableFull>
                                        </div>
                                    )}
                            </div>
                        </div>
                        <hr />
                        <div className="row">
                            <RelatedLinks />
                            <hr />
                        </div>
                    </div>
                </div>
                <div className="col" >
                    <SecondAds />
                    <br />
                    <MainCalculatorsList CalculatorsTypeId={CalculatorsType.womenCalculators}></MainCalculatorsList>
                    <br />
                </div>
            </div>
            <div className="row" style={{ height: 'auto' }} >
                <div className="col-12 col-md-8">
                    <div className="info-sections-container">
                        <div className="info-section">
                            <div className="info-section-header">Description of Menstrual Cycle Calculator:</div>
                            <div className="info-section-body">
                                <h2 style={{ fontSize: '15px' }}>How Pregnancy Occurs in Women
                                </h2>
                                <p>Pregnancy occurs in women when a man's sperm fertilizes a mature egg released by the woman, which happens once a month. It's known that this egg lives for a very short time, estimated from 12 to 24 hours. To ensure pregnancy, a man needs to have intercourse with a woman during this period known as the ovulation period. It's also possible to avoid intercourse during this period to naturally control birth without relying on any medical methods.
                                </p>
                                <u><b>Ovulation and Fertilization</b></u>
                                <br />
                                In humans, ovulation is the process where the ovaries rupture to release a mature egg, usually occurring within four days before or after the midpoint of a woman's menstrual cycle (14 days before her next menstrual period).
                                <br/>                                Days 10-18 of the menstrual cycle (on average) are the most fertile phase. This is crucial when trying to conceive because fertilization of the egg can only happen for 12-24 hours after its release during the second part of the menstrual cycle when the mature egg travels through the fallopian tubes toward the uterus. Since sperm can live inside a woman's body for up to five days, having regular intercourse five days before and on the day of ovulation can increase the chances of pregnancy. If the egg is fertilized, it will implant in the uterus after 6-12 days; otherwise, menstruation occurs, and blood and mucous tissue are shed from the uterine lining.
                                <br/>                                <u><b>Estimating Ovulation</b></u>
                                <br />
                                <br/>                                The cycle optimizer is a tool for estimating the most likely days of menstruation and ovulation using a calendar format. Menstrual days are the days when bleeding and discharge occur. The most likely ovulation days are the days when a woman is most likely to ovulate.
                                 <br/><hr />
                                <h2 style={{ fontSize: '15px' }}>How to Calculate Ovulation Days
                                </h2>
                                <p>As mentioned earlier, the ovulation period lasts from 12 to 24 hours, and this period cannot be accurately determined. However, in our calculation process, the ovulation period is approximately 14 days before the start of a woman's menstrual period. Therefore, in the Gregorian or Hijri ovulation calculator, we take the length of the menstrual cycle (the period between one menstrual period and the next) and add it to the date of the first day of the last menstrual period. Then, we subtract two weeks from that date, which is expected to be the ovulation period. Afterward, we take two days before and two days after that date to create an approximate range around the ovulation period, called the ovulation days. This gives us five days of ovulation, during which there will be 12 to 24 hours when the egg is mature and ready for fertilization by the man's sperm. Women who want to conceive should aim to have intercourse during these ovulation days.
                                </p>
                                <br />
                                <hr />
                                <h2 style={{ fontSize: '15px' }}>Using the Ovulation Calculator
                                </h2>
                                <p>To use the ovulation calculator after your menstrual period, a woman needs to have complete knowledge of the first day of her last menstrual period and the length of the time between one menstrual period and the next. With this information, the ovulation period can be calculated in seconds using our website by entering the mentioned data. If the information is inaccurate, the result of the ovulation calculation will also be inaccurate, and it cannot be relied upon for any purpose, whether for the purpose of pregnancy or birth control. Accuracy is crucial here.
                                </p>
                                <br />
                                <hr />
                                <b>Last Reviewed Date:</b> 28/02/2026
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default OvulationCalculator;
